document.addEventListener('DOMContentLoaded', () => {

    if (!localStorage.getItem('neo_retro_mode_active') && 
        !localStorage.getItem('horror_mode_active') && 
        !localStorage.getItem('terminal_mode_active') && 
        !localStorage.getItem('theme')) {
        
        localStorage.setItem('neo_retro_mode_active', 'true');
        document.body.classList.add('neo-retro-mode');
    }

    const swiperInstances = {};

    function runSafely(fn, fnName) {
        try {
            fn();
        } catch (e) {
            if (!(e instanceof TypeError && e.message.includes('null'))) {
                console.error(`Error in ${fnName}:`, e);
            }
        }
    }

    function triggerHaptic() {
        if (navigator.vibrate) {
            navigator.vibrate(10);
        }
    }

    // ==========================================================================
    //  Focus Mode / Sidebar Hide 
    // ==========================================================================

    function initializeFocusMode() {
        const body = document.body;
        const focusButton = document.getElementById('focus-mode-toggle');

        if (!focusButton) return;
        const storedState = localStorage.getItem('focusMode');
        if (storedState === 'enabled') {
            body.classList.add('focus-mode');
            focusButton.classList.add('active');
        }

        focusButton.addEventListener('click', () => {
            triggerHaptic();

            const wasActive = body.classList.contains('focus-mode');
            if (wasActive) {
                body.classList.remove('focus-mode');
                focusButton.classList.remove('active');
                localStorage.setItem('focusMode', 'disabled');
            } else {
                body.classList.add('focus-mode');
                focusButton.classList.add('active');
                localStorage.setItem('focusMode', 'enabled');
            }
        });
    }

    // ==========================================================================
    //  Theme Manager 
    // ==========================================================================
    
    const cleanUpRetroDOM = () => {
        const articleContent = document.querySelector('.article-content');
        if (!articleContent) return;

        const figures = articleContent.querySelectorAll('figure.retro-frame');
        figures.forEach(figure => {
            figure.classList.remove('retro-frame');
            figure.style.padding = '';
            const img = figure.querySelector('img');
            if(img) { img.style.width = ''; img.style.borderBottom = ''; }
            const caption = figure.querySelector('figcaption');
            if(caption) { caption.style = ''; }
        });

        const retroHrs = articleContent.querySelectorAll('.retro-hr');
        retroHrs.forEach(el => el.remove());
        const hrs = articleContent.querySelectorAll('hr');
        hrs.forEach(hr => hr.style.display = '');
    };

    function resetAllThemes() {
        const body = document.body;
        const allThemes = ['dark-mode', 'horror-theme', 'gaming-mode', 'terminal-mode', 'neo-retro-mode'];
        const allToggles = ['dark-mode-toggle', 'horror-mode-toggle', 'terminal-mode-toggle', 'neo-retro-mode-toggle'];

        allThemes.forEach(theme => body.classList.remove(theme));
        allToggles.forEach(id => {
            const btn = document.getElementById(id);
            if (btn) btn.classList.remove('active');
        });

        localStorage.setItem('terminal_mode_active', 'false');
        localStorage.setItem('horror_mode_active', 'false');
        localStorage.setItem('neo_retro_mode_active', 'false');

        cleanUpRetroDOM();
        setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
    }

    // ==========================================================================
    //  Theme Initializations
    // ==========================================================================

    function initDarkMode() {
        const toggleButton = document.getElementById('dark-mode-toggle');
        if (!toggleButton) return;
        const body = document.body;
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        if (localStorage.getItem('terminal_mode_active') !== 'true' && 
            localStorage.getItem('horror_mode_active') !== 'true' && 
            localStorage.getItem('neo_retro_mode_active') !== 'true') {
            
            const currentTheme = localStorage.getItem('theme');
            if (currentTheme === 'dark' || (!currentTheme && prefersDark)) {
                body.classList.add('dark-mode');
                toggleButton.classList.add('active');
            }
        }

        toggleButton.addEventListener('click', () => {
            triggerHaptic();
            const wasActive = body.classList.contains('dark-mode');
            resetAllThemes();

            if (!wasActive) {
                body.classList.add('dark-mode');
                toggleButton.classList.add('active');
                localStorage.setItem('theme', 'dark');
            } else {
                localStorage.setItem('theme', 'light');
            }
        });
    }

    function initHorrorMode() {
        const toggleButton = document.getElementById('horror-mode-toggle');
        if (!toggleButton) return;

        if (localStorage.getItem('horror_mode_active') === 'true') {
            resetAllThemes(); 
            document.body.classList.add('horror-theme');
            toggleButton.classList.add('active');
        }

        toggleButton.addEventListener('click', () => {
            triggerHaptic();
            const wasActive = document.body.classList.contains('horror-theme');
            resetAllThemes();

            if (!wasActive) {
                document.body.classList.add('horror-theme');
                toggleButton.classList.add('active');
                localStorage.setItem('horror_mode_active', 'true');
            }
        });
    }

    function initTerminalMode() {
        const toggleButton = document.getElementById('terminal-mode-toggle');
        if (!toggleButton) return;

        if (localStorage.getItem('terminal_mode_active') === 'true') {
            resetAllThemes();
            document.body.classList.add('terminal-mode');
            toggleButton.classList.add('active');
        }

        toggleButton.addEventListener('click', () => {
            triggerHaptic();
            const wasActive = document.body.classList.contains('terminal-mode');
            resetAllThemes();

            if (!wasActive) {
                document.body.classList.add('terminal-mode');
                toggleButton.classList.add('active');
                localStorage.setItem('terminal_mode_active', 'true');
            }
        });
    }

    // --- Neo Retro Mode ---
    function initNeoRetroMode() {
        const toggleButton = document.getElementById('neo-retro-mode-toggle');
        if (!toggleButton) return;
        const body = document.body;

        const forceMobileImageExpansion = () => {
            if (!body.classList.contains('neo-retro-mode')) return;
            
            if (window.innerWidth <= 768) {
                const frames = document.querySelectorAll('.retro-frame');
                frames.forEach(frame => {
                    frame.style.padding = '0px 0px 30px 0px'; 
                    const img = frame.querySelector('img');
                    if (img) {
                        img.style.width = '100%';
                        img.style.display = 'block';
                        img.style.borderBottom = '2px solid var(--ink-black)';
                    }
                    const caption = frame.querySelector('figcaption');
                    if (caption) {
                        caption.style.bottom = '0';
                        caption.style.left = '0';
                        caption.style.width = '100%';
                        caption.style.padding = '0 10px';
                        caption.style.height = '30px';
                        caption.style.display = 'flex';
                        caption.style.alignItems = 'center';
                    }
                });
            } else {
                const frames = document.querySelectorAll('.retro-frame');
                frames.forEach(frame => {
                    frame.style.padding = '';
                    const img = frame.querySelector('img');
                    if (img) { img.style.width = ''; img.style.borderBottom = ''; }
                    const caption = frame.querySelector('figcaption');
                    if (caption) { caption.style = ''; }
                });
            }
        };

        const applyRetroStructure = () => {
            const articleContent = document.querySelector('.article-content');
            if (!articleContent) return;

            const allFigures = articleContent.querySelectorAll('figure.article-image');
            const targetFigures = Array.from(allFigures).filter(figure => {
                return !figure.closest('.swiper-slide') && 
                        !figure.closest('.performance-card') && 
                        !figure.closest('.spec-chart-section') && 
                        !figure.closest('.feature-card') && 
                        !figure.closest('.mobile-summary-card') && 
                        !figure.closest('table'); 
            });

            targetFigures.forEach(figure => {
                figure.classList.add('retro-frame');
            });

            const hrs = articleContent.querySelectorAll('hr');
            hrs.forEach(hr => {
                if (hr.style.display === 'none' && hr.nextElementSibling?.classList.contains('retro-hr')) return;
                hr.style.display = 'none'; 
                const retroHr = document.createElement('div');
                retroHr.className = 'retro-hr';
                hr.after(retroHr); 
            });
            
            forceMobileImageExpansion();
        };

        window.addEventListener('resize', () => {
            if (body.classList.contains('neo-retro-mode')) {
                forceMobileImageExpansion();
            }
        });

        if (localStorage.getItem('neo_retro_mode_active') === 'true') {
            resetAllThemes();
            body.classList.add('neo-retro-mode');
            toggleButton.classList.add('active');
            applyRetroStructure();
        }

        toggleButton.addEventListener('click', () => {
            triggerHaptic();
            const wasActive = body.classList.contains('neo-retro-mode');
            resetAllThemes();

            if (!wasActive) {
                body.classList.add('neo-retro-mode');
                toggleButton.classList.add('active');
                localStorage.setItem('neo_retro_mode_active', 'true');
                applyRetroStructure();
            }
        });
    }

    // ==========================================================================
    //  UI Effects & Others
    // ==========================================================================

    function initFitText() {
        const element = document.querySelector('.parallax-title-bg');
        if (!element) return;
        const fit = () => {
            if (!element.parentElement) return; 
            const containerWidth = element.parentElement.clientWidth;
            let fontSize = 25; 
            element.style.fontSize = fontSize + 'vw';
            while (element.scrollWidth > containerWidth - 20 && fontSize > 1) {
                fontSize -= 0.5;
                element.style.fontSize = fontSize + 'vw';
            }
        };
        fit(); 
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(fit, 100);
        });
    }

    function initParallaxHeader() {
        const bg = document.querySelector('.parallax-bg');
        const bgText = document.querySelector('.parallax-title-bg');
        const content = document.querySelector('.parallax-content');
        if (!bg || !bgText || !content) return;

        let ticking = false;
        const parallaxScroll = () => {
            const scrollY = window.scrollY;
            bg.style.transform = `translateY(${scrollY * 0.3}px)`;
            bgText.style.transform = `translate(-50%, -50%) translateY(${scrollY * 0.5}px)`;
            content.style.transform = `translateY(${scrollY * 0.7}px)`;
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(parallaxScroll);
                ticking = true;
            }
        }, { passive: true });
    }

    function initScrollAnimations() {
        const animatedElements = document.querySelectorAll('.article-section, hr.animated');
        if (!("IntersectionObserver" in window)) {
            animatedElements.forEach(el => el.classList.add('is-visible'));
            return;
        }
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    obs.unobserve(entry.target); 
                }
            });
        }, { rootMargin: "0px 0px -50px 0px", threshold: 0 });
        animatedElements.forEach(el => observer.observe(el));
        document.querySelector('.article-header.parallax-content')?.classList.add('is-visible');
    }

    function initGlobalTabs() {
        document.body.addEventListener('click', (e) => {
            const button = e.target.closest('[data-tab]');
            if (!button) return;

            const targetId = button.dataset.tab;
            const contentAttr = button.hasAttribute('data-material') ? 'data-material-content' : 'data-tab-content';
            const btnGroup = button.parentElement;
            
            if (btnGroup) {
                btnGroup.querySelectorAll('[data-tab], [data-material]').forEach(btn => btn.classList.remove('active'));
            }
            button.classList.add('active');

            const container = button.closest('.article-content') || document.body;
            const targetContent = container.querySelector(`[${contentAttr}="${targetId}"]`);

            if (targetContent) {
                const parentContainer = targetContent.parentElement;
                parentContainer.querySelectorAll(`[${contentAttr}]`).forEach(content => {
                    content.classList.remove('active');
                    content.style.display = 'none'; 
                });
                
                targetContent.classList.add('active');
                targetContent.style.display = 'block';
                targetContent.style.opacity = 0;
                requestAnimationFrame(() => {
                    targetContent.style.transition = 'opacity 0.3s ease';
                    targetContent.style.opacity = 1;
                });
            }
        });
    }

    function initSmoothScroll() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (href && href.length > 1) {
                    try {
                        const targetElement = document.querySelector(href);
                        if (targetElement) {
                            e.preventDefault();
                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    } catch (error) {
                        console.warn(`Smooth scroll target not found: ${href}`, error);
                    }
                }
            });
        });
    }

    function initTocHighlightAndAccordion() {
        const headings = Array.from(document.querySelectorAll('.article-content h2[id], .article-content h3[id]'));
        const tocContainer = document.querySelector('.article-sidebar .table-of-contents');
        const tocLinks = document.querySelectorAll('.article-sidebar .table-of-contents a');
        const sidebar = document.querySelector('.article-sidebar');
        
        const stopperSelectors = [
            '.related-articles', '.related-posts', '.related-products', '.article-recommendations',
            '.next-article', '.article-navigation', '.article-footer', '.blog-footer',
            '#shopify-section-footer', '.site-footer', 'footer'
        ];

        let stopperElement = null;
        for (const selector of stopperSelectors) {
            const el = document.querySelector(selector);
            if (el) { stopperElement = el; break; }
        }

        if (headings.length === 0 || !tocContainer) return;

        let lastActiveId = '';
        let isTicking = false;

        const updateSidebar = () => {
            const scrollY = window.scrollY;
            const triggerLine = 150; 
            let currentHeading = headings[0];

            for (let i = 0; i < headings.length; i++) {
                const rect = headings[i].getBoundingClientRect();
                if (rect.top <= triggerLine) {
                    currentHeading = headings[i];
                } else {
                    break;
                }
            }

            if (currentHeading) {
                activateLink(currentHeading.getAttribute('id'));
            }

            if (sidebar && stopperElement) {
                const sidebarRect = sidebar.getBoundingClientRect();
                const stopperRect = stopperElement.getBoundingClientRect();
                const style = window.getComputedStyle(sidebar);
                const matrix = new WebKitCSSMatrix(style.transform);
                const currentTranslateY = matrix.m42; 
                const rawSidebarBottom = sidebarRect.bottom - currentTranslateY;
                const buffer = 40;
                const overlap = (rawSidebarBottom + buffer) - stopperRect.top;

                if (overlap > 0) {
                    sidebar.style.transform = `translateY(-${overlap}px)`;
                } else {
                    sidebar.style.transform = 'none';
                }
            }
            isTicking = false;
        };

        const activateLink = (id) => {
            if (lastActiveId === id) return;
            lastActiveId = id;

            tocLinks.forEach(link => link.classList.remove('active'));

            const activeLink = document.querySelector(`.article-sidebar .table-of-contents a[href="#${id}"]`);
            if (activeLink) {
                activeLink.classList.add('active');
                
                const parentLi = activeLink.closest('li');
                if (parentLi) {
                    const parentUl = parentLi.closest('ul');
                    if (parentUl && parentUl.classList.contains('toc-sub-list')) {
                        const grandParentLi = parentUl.closest('li');
                        if (grandParentLi) grandParentLi.classList.add('is-open');
                    }
                    if (parentLi.classList.contains('has-submenu')) {
                        parentLi.classList.add('is-open');
                    }
                }
                if (window.innerWidth >= 993) {
                    setTimeout(() => {
                        const containerHeight = tocContainer.clientHeight;
                        const linkTop = activeLink.offsetTop;
                        const linkHeight = activeLink.clientHeight;
                        const targetScroll = linkTop - (containerHeight / 2) + (linkHeight / 2);
                        tocContainer.scrollTo({ top: targetScroll, behavior: 'smooth' });
                    }, 50);
                }
            }
        };

        window.addEventListener('scroll', () => {
            if (!isTicking) {
                window.requestAnimationFrame(updateSidebar);
                isTicking = true;
            }
        }, { passive: true });
        
        setTimeout(updateSidebar, 100);
        window.addEventListener('resize', updateSidebar);
    }

    function initTocAccordionClick() {
        const tocListItems = document.querySelectorAll('.article-sidebar .table-of-contents li');
        tocListItems.forEach(li => {
            const subUl = Array.from(li.children).find(child => child.tagName === 'UL');
            if (subUl) {
                subUl.classList.add('toc-sub-list'); 
                li.classList.add('has-submenu');    
                const toggle = document.createElement('span');
                toggle.className = 'toc-toggle';
                toggle.textContent = '›';
                toggle.setAttribute('aria-hidden', 'true'); 
                toggle.addEventListener('click', (e) => {
                    e.stopPropagation(); 
                    li.classList.toggle('is-open');
                });
                li.prepend(toggle);
            }
        });
    }

    function initProductSlider() {
        document.querySelectorAll('.article-slider-wrapper').forEach(wrapper => {
            const sliderEl = wrapper.querySelector('.product-slider');
            if (!sliderEl || typeof Swiper === 'undefined') return; 
            const slides = sliderEl.querySelectorAll('.swiper-slide');
            const sliderId = sliderEl.id;
            let swiper;
            let manualButtons = [];
            let buttonContainer = null; 
            let descriptionWrapper = null; 
            const swiperOptions = {
                loop: slides.length > 1, 
                navigation: {
                    nextEl: wrapper.querySelector('.swiper-button-next'),
                    prevEl: wrapper.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: wrapper.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                on: {} 
            };
            if (sliderId) {
                buttonContainer = document.querySelector(`.manual-slide-controls[data-target-slider="${sliderId}"]`);
                descriptionWrapper = document.querySelector(`.slider-description-wrapper[data-slider-id="${sliderId}"]`);
                if (buttonContainer) {
                    manualButtons = buttonContainer.querySelectorAll('.slide-to-btn');
                }
                swiperOptions.on.realIndexChange = (s) => {
                    const activeIndex = s.realIndex;
                    if (buttonContainer) {
                        manualButtons.forEach(btn => btn.classList.remove('active'));
                        buttonContainer.querySelector(`.slide-to-btn[data-slide="${activeIndex}"]`)?.classList.add('active');
                    }
                    if (descriptionWrapper) {
                        descriptionWrapper.querySelectorAll('.slider-description').forEach(desc => desc.classList.remove('active'));
                        descriptionWrapper.querySelector(`.slider-description[data-slide="${activeIndex}"]`)?.classList.add('active');
                    }
                };
            } else if (slides.length > 1) {
                swiperOptions.autoplay = { delay: 4000, disableOnInteraction: false };
            }
            swiper = new Swiper(sliderEl, swiperOptions);
            manualButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const slideIndex = parseInt(button.dataset.slide, 10);
                    if (swiper.params.loop) swiper.slideToLoop(slideIndex);
                    else swiper.slideTo(slideIndex);
                });
            });
            if (sliderId) swiperInstances[sliderId] = swiper;
        });
    }

    function initRadarChart() {
        const canvas = document.getElementById('radar-chart');
        if (!canvas || typeof Chart === 'undefined') return;
        let existingChart = Chart.getChart(canvas);
        if (existingChart) existingChart.destroy();

        const dataElements = document.querySelectorAll('#chart-data li[data-label][data-score]'); 
        if (dataElements.length === 0) return; 

        const isMobile = window.innerWidth <= 768;
        const labels = Array.from(dataElements, el => {
            const label = el.dataset.label || 'N/A'; 
            const score = el.dataset.score || '0'; 
           return isMobile ? [label, `(${score})`] : `${label}: ${score}`;
        });
        const data = Array.from(dataElements, el => parseInt(el.dataset.score, 10) || 0);
        const totalScoreEl = document.getElementById('total-score-value');
        if (totalScoreEl) {
            const totalScore = data.reduce((sum, value) => sum + value, 0); 
            totalScoreEl.textContent = totalScore;
        }

        const getChartColors = () => {
            const rootStyle = getComputedStyle(document.body); 
            const accentColor = rootStyle.getPropertyValue('--accent-primary-color').trim() || '#D4A373';
            const textHeading = rootStyle.getPropertyValue('--text-heading').trim() || 'rgba(0, 0, 0, 0.8)';
            const borderColor = rootStyle.getPropertyValue('--border-color').trim() || 'rgba(0, 0, 0, 0.1)';
            const surfaceColor = rootStyle.getPropertyValue('--surface').trim() || '#ffffff'; 
            const isDark = document.body.classList.contains('dark-mode');

            const colors = {
                grid: isDark ? 'rgba(255, 255, 255, 0.2)' : borderColor,
                pointLabels: isDark ? 'rgba(255, 255, 255, 0.8)' : textHeading,
                background: isDark ? 'rgba(212, 163, 115, 0.3)' : 'rgba(212, 163, 115, 0.2)',
                border: accentColor,
                pointBorder: surfaceColor 
            };
             if (document.body.classList.contains('horror-theme')) {
                 colors.grid = 'rgba(159, 29, 29, 0.4)'; colors.pointLabels = '#9f1d1d'; colors.background = 'rgba(159, 29, 29, 0.3)'; colors.border = '#c0392b'; colors.pointBorder = '#1a1a1a'; 
             }
             if (document.body.classList.contains('terminal-mode')) {
                 colors.grid = 'rgba(51, 255, 0, 0.4)'; colors.pointLabels = '#33ff00'; colors.background = 'rgba(51, 255, 0, 0.2)'; colors.border = '#33ff00'; colors.pointBorder = '#000000'; 
             }
             if (document.body.classList.contains('neo-retro-mode')) {
                 colors.border = '#E63946'; 
                 colors.pointLabels = '#111111'; 
                 colors.grid = '#111111'; 
                 colors.pointBorder = '#111111';
                 colors.background = 'rgba(230, 57, 70, 0.2)';
             }
            return colors;
        };

        const chartColors = getChartColors(); 
        const chart = new Chart(canvas, {
            type: 'radar',
            data: {
                labels: labels,
                datasets: [{
                    label: '評価',
                    data: data,
                    backgroundColor: chartColors.background,
                    borderColor: chartColors.border,
                    pointBackgroundColor: chartColors.border,
                    pointBorderColor: chartColors.pointBorder, 
                    pointHoverBackgroundColor: chartColors.pointBorder,
                    pointHoverBorderColor: chartColors.border,
                    borderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointBorderWidth: 2 
                }]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: {
                    r: {
                        angleLines: { color: chartColors.grid }, grid: { color: chartColors.grid },
                        pointLabels: { font: { size: isMobile ? 11 : 13, family: "'Lato', sans-serif", weight: '500' }, color: chartColors.pointLabels },
                        ticks: { display: false, stepSize: 2 }, min: 0, max: 10
                    }
                },
                plugins: { legend: { display: false }, tooltip: { enabled: false } },
                animation: { duration: 800, easing: 'easeOutQuad' }
            }
        });

        const updateChartColors = () => {
            const chartInstance = Chart.getChart(canvas);
            if (!chartInstance) return;
            const newColors = getChartColors();
            const scale = chartInstance.options.scales.r;
            const dataset = chartInstance.data.datasets[0];
            scale.angleLines.color = newColors.grid; scale.grid.color = newColors.grid; scale.pointLabels.color = newColors.pointLabels;
            dataset.backgroundColor = newColors.background; dataset.borderColor = newColors.border;
            dataset.pointBackgroundColor = newColors.border; dataset.pointBorderColor = newColors.pointBorder; 
            dataset.pointHoverBorderColor = newColors.border; dataset.pointHoverBackgroundColor = newColors.pointBorder; 
            chartInstance.update('none');
        };

        ['dark-mode-toggle', 'horror-mode-toggle', 'terminal-mode-toggle', 'neo-retro-mode-toggle'].forEach(id => {
            document.getElementById(id)?.addEventListener('click', () => setTimeout(updateChartColors, 50));
        });
        let resizeTimerChart;
        window.addEventListener('resize', () => {
             clearTimeout(resizeTimerChart); resizeTimerChart = setTimeout(updateChartColors, 250);
        });
    }

    function initAudioEqualizer() {
        const audio = document.getElementById('typing-audio');
        const playBtn = document.getElementById('play-sound-btn');
        const canvas = document.getElementById('audio-eq-canvas');
        if (!audio || !playBtn || !canvas) return;

        const ctx = canvas.getContext('2d');
        let audioContext, analyser, source, animationFrameId;
        let isInitialized = false;

        const setupAudio = () => {
            if (isInitialized || (!window.AudioContext && !window.webkitAudioContext)) { playBtn.disabled = true; return; }
            try {
                audioContext = new (window.AudioContext || window.webkitAudioContext)();
                source = audioContext.createMediaElementSource(audio);
                analyser = audioContext.createAnalyser();
                analyser.fftSize = 64; 
                source.connect(analyser);
                source.connect(audioContext.destination);
                isInitialized = true;
            } catch (error) { console.error("Failed to initialize AudioContext:", error); playBtn.disabled = true; }
        };

        const draw = () => {
            if (!analyser || !isInitialized || !ctx) return;
            animationFrameId = requestAnimationFrame(draw);
            const bufferLength = analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            analyser.getByteFrequencyData(dataArray);
            const WIDTH = canvas.width; const HEIGHT = canvas.height;
            ctx.clearRect(0, 0, WIDTH, HEIGHT);
            const barWidth = (WIDTH / bufferLength) * 1.5;
            let barHeight; let x = 0;

            let accentColor = getComputedStyle(document.body).getPropertyValue('--accent-primary-color').trim();
            if (!accentColor) accentColor = '#D4A373';
            if(document.body.classList.contains('terminal-mode')) accentColor = '#33ff00';

            ctx.fillStyle = accentColor;
            for (let i = 0; i < bufferLength; i++) {
                barHeight = (dataArray[i] / 255.0) * HEIGHT * 0.8; 
                barHeight = Math.max(barHeight, 1); 
                ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);
                x += barWidth + 2; 
            }
        };

        const setIcon = (iconClass) => {
            const icon = playBtn.querySelector('i');
            if (icon) icon.className = `fa-solid ${iconClass}`;
        };
        playBtn.addEventListener('click', () => {
            if (!isInitialized) setupAudio();
            if (audioContext && audioContext.state === 'suspended') audioContext.resume().catch(console.error);
            if (audio.paused) {
                const playPromise = audio.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        console.error("Audio play failed:", error);
                        setIcon('fa-play');
                        if (typeof animationFrameId !== 'undefined') cancelAnimationFrame(animationFrameId);
                    });
                }
            } else {
                audio.pause();
            }
        });
        audio.addEventListener('play', () => { setIcon('fa-pause'); draw(); });
        audio.addEventListener('pause', () => { setIcon('fa-play'); if (typeof animationFrameId !== 'undefined') cancelAnimationFrame(animationFrameId); });
        audio.addEventListener('ended', () => {
            setIcon('fa-play');
            if (typeof animationFrameId !== 'undefined') cancelAnimationFrame(animationFrameId);
            setTimeout(() => ctx?.clearRect(0, 0, canvas.width, canvas.height), 100);
        });
    }

    function initSimulator() {
        const simulator = document.getElementById('ap-rt-simulator');
        if (!simulator) return;
        const startBtn = document.getElementById('sim-start-btn'), canvas = document.getElementById('sim-graph-canvas'), key = document.getElementById('sim-key'), apSlider = document.getElementById('ap-slider'), rtSlider = document.getElementById('rt-slider'), ksSlider = document.getElementById('ks-slider'), apValueSpan = document.getElementById('ap-value'), rtValueSpan = document.getElementById('rt-value'), ksValueSpan = document.getElementById('ks-value'), modeBtn = document.getElementById('sim-mode-btn');
        if (!startBtn || !canvas) return;
        const ctx = canvas.getContext('2d');
        let state = { isActive: false, isPressed: false, isActuated: false, currentDepth: 0, velocity: 0, deepestPoint: 0, previousDepth: 0, ap: parseFloat(apSlider?.value || 2.0), rt: parseFloat(rtSlider?.value || 0.1), mode: 'rt', maxTravel: parseFloat(ksSlider?.value || 3.5) };
        let path = [], animationFrameId;
        const resizeCanvas = () => { if (!canvas.parentElement) return; const dpr = window.devicePixelRatio || 1; const rect = canvas.parentElement.getBoundingClientRect(); canvas.width = rect.width * dpr; canvas.height = rect.height * dpr; ctx.scale(dpr, dpr); };
        const drawGraph = () => {
            animationFrameId = requestAnimationFrame(drawGraph);
            state.previousDepth = state.currentDepth;
            const targetDepth = state.isPressed ? state.maxTravel : 0;
            state.velocity += (targetDepth - state.currentDepth) * 0.015;
            state.velocity *= 0.90;
            state.currentDepth += state.velocity;
            if (Math.abs(state.velocity) < 0.001 && Math.abs(targetDepth - state.currentDepth) < 0.001) state.currentDepth = targetDepth;
            const isPressingDown = state.currentDepth > state.previousDepth;
            if (isPressingDown) { state.deepestPoint = Math.max(state.deepestPoint, state.currentDepth); if (!state.isActuated && state.currentDepth >= state.ap) state.isActuated = true; } 
            else if (state.isActuated) { const resetPoint = state.mode === 'rt' ? state.deepestPoint - state.rt : state.ap - state.rt; if (state.currentDepth <= resetPoint) { state.isActuated = false; state.deepestPoint = state.currentDepth; } } 
            else { state.deepestPoint = state.currentDepth; }
            const width = canvas.clientWidth, height = canvas.clientHeight;
            ctx.clearRect(0, 0, width, height);
            path.push(state.currentDepth);
            if (path.length > width / 2) path.shift();
            const drawLine = (y, color, dash = []) => { ctx.lineWidth = 1; ctx.setLineDash(dash); ctx.strokeStyle = getComputedStyle(document.documentElement).getPropertyValue(color).trim(); ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(width, y); ctx.stroke(); };
            drawLine((state.ap / state.maxTravel * height), '--accent-primary-color', [5, 3]);
            if (state.mode === 'rt' && state.isActuated) drawLine(((state.deepestPoint - state.rt) / state.maxTravel * height), '--pros-color', [5, 3]);
            ctx.setLineDash([]);
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = getComputedStyle(document.documentElement).getPropertyValue(state.isActuated ? '--pros-color' : '--text-secondary').trim();
            path.forEach((p, i) => { const y = (p / state.maxTravel * height); i === 0 ? ctx.moveTo(i * 2, y) : ctx.lineTo(i * 2, y); });
            ctx.stroke();
            if (key) { key.style.transform = `translateY(${state.currentDepth / state.maxTravel * 20}px)`; key.classList.toggle('actuated', state.isActuated); }
        };
        const toggleSimulator = (on) => {
            state.isActive = on;
            simulator.classList.toggle('active', on);
            if (on) { path = [0]; state.currentDepth = 0; state.velocity = 0; state.deepestPoint = 0; state.isActuated = false; window.addEventListener('keydown', onKeyDown); window.addEventListener('keyup', onKeyUp); animationFrameId = requestAnimationFrame(drawGraph); startBtn.innerHTML = '<i class="fa-solid fa.stop"></i> シミュレーターを停止'; } 
            else { window.removeEventListener('keydown', onKeyDown); window.removeEventListener('keyup', onKeyUp); cancelAnimationFrame(animationFrameId); startBtn.innerHTML = '<i class="fa-solid fa-play"></i> シミュレーターを開始'; }
        };
        const onKeyDown = (e) => { if (e.key.toLowerCase() === 'w' && !e.repeat) state.isPressed = true; };
        const onKeyUp = (e) => { if (e.key.toLowerCase() === 'w') state.isPressed = false; };
        startBtn.addEventListener('click', () => toggleSimulator(!state.isActive));
        apSlider?.addEventListener('input', e => { state.ap = parseFloat(e.target.value); if(apValueSpan) apValueSpan.textContent = state.ap.toFixed(2); });
        rtSlider?.addEventListener('input', e => { state.rt = parseFloat(e.target.value); if(rtValueSpan) rtValueSpan.textContent = state.rt.toFixed(2); });
        ksSlider?.addEventListener('input', e => { state.maxTravel = parseFloat(e.target.value); if(ksValueSpan) ksValueSpan.textContent = state.maxTravel.toFixed(1); });
        modeBtn?.addEventListener('click', () => { state.mode = state.mode === 'rt' ? 'normal' : 'rt'; modeBtn.textContent = state.mode === 'rt' ? 'ラピッドトリガーモード' : '通常モード'; if(rtSlider) rtSlider.disabled = state.mode === 'normal'; });
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);
    }
    
    function initKeyboardFinder() {
        const container = document.getElementById('keyboard-selector');
        if (!container) return;
        const options = container.querySelectorAll('.finder-option'), results = container.querySelectorAll('.keyboard-result'), resultSection = container.querySelector('.result-section'), productSpecs = container.querySelector('.product-specs'), noResultsMessage = container.querySelector('#no-results-message');
        const updateOptionStates = () => {
            const activeFilters = Array.from(container.querySelectorAll('.finder-option.selected'));
            options.forEach(option => {
                if (option.classList.contains('selected')) { option.classList.remove('disabled'); return; }
                const keyToTest = option.dataset.filterKey;
                const tempFilters = [...activeFilters.filter(f => f.dataset.filterKey !== keyToTest), option];
                let potentialMatches = 0;
                results.forEach(row => { if (tempFilters.every(filter => filter.dataset.filterValue === 'any' || row.dataset[filter.dataset.filterKey]?.split(',').includes(filter.dataset.filterValue))) potentialMatches++; });
                option.classList.toggle('disabled', potentialMatches === 0);
            });
        };
        const applyFilters = () => {
            const activeFilters = Array.from(container.querySelectorAll('.finder-option.selected'));
            if (activeFilters.length === 0) { resultSection.style.display = 'none'; options.forEach(opt => opt.classList.remove('disabled')); return; }
            let matchCount = 0;
            results.forEach(row => {
                const isMatch = activeFilters.every(filter => filter.dataset.filterValue === 'any' || row.dataset[filter.dataset.filterKey]?.split(',').includes(filter.dataset.filterValue));
                row.style.display = isMatch ? '' : 'none';
                if (isMatch) matchCount++;
            });
            resultSection.style.display = 'block';
            productSpecs.style.display = matchCount > 0 ? 'block' : 'none';
            noResultsMessage.style.display = matchCount > 0 ? 'none' : 'block';
            updateOptionStates();
        };
        options.forEach(option => {
            option.addEventListener('click', function() {
                if (this.classList.contains('disabled')) return;
                const parent = this.closest('.finder-options');
                const wasSelected = this.classList.contains('selected');
                parent.querySelectorAll('.finder-option').forEach(opt => opt.classList.remove('selected'));
                if (!wasSelected) this.classList.add('selected');
                applyFilters();
            });
        });
        updateOptionStates();
    }
    
    function initRankingSort() {
        const sortControls = document.querySelector('.sort-controls'), tableBody = document.getElementById('keyboard-ranking-tbody');
        if (!sortControls || !tableBody) return;
        const sortTable = (sortKey) => {
            const rows = Array.from(tableBody.querySelectorAll('tr'));
            const colIndex = (sortKey === 'reset') ? 1 : 2;
            sortControls.querySelectorAll('.sort-btn').forEach(btn => btn.classList.toggle('active', btn.dataset.sortKey === sortKey));
            rows.sort((a, b) => {
                const valA = parseFloat(a.cells[colIndex].textContent), valB = parseFloat(b.cells[colIndex].textContent);
                if (isNaN(valA)) return 1;
                if (isNaN(valB)) return -1;
                return valA - valB;
            });
            rows.forEach(row => tableBody.appendChild(row));
        };
        sortControls.addEventListener('click', (e) => { if (e.target.matches('.sort-btn')) sortTable(e.target.dataset.sortKey); });
        sortTable('reset');
    }

    function initImageLightbox() {
        const overlay = document.getElementById('lightbox-overlay');
        const image = document.getElementById('lightbox-image');
        const closeBtn = document.getElementById('lightbox-close-btn');
        if (!overlay || !image || !closeBtn) return;
        const closeLightbox = () => overlay.classList.remove('visible');
        document.body.addEventListener('click', e => {
            let imageTarget = null;
            if (e.target.matches('.article-slider-wrapper .swiper-slide img')) imageTarget = e.target;
            else if (e.target.closest('.performance-image, figure.article-image.full-width')) {
                 const container = e.target.closest('figure.article-image, .performance-image');
                 imageTarget = container?.querySelector('img');
            }
            if (imageTarget && imageTarget.src) {
                e.stopPropagation(); image.src = imageTarget.src; overlay.classList.add('visible');
            }
        });
        closeBtn.addEventListener('click', closeLightbox);
        overlay.addEventListener('click', e => { if (e.target === overlay) closeLightbox(); });
        document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
    }

    function initXShareButton() {
        const shareButton = document.getElementById('share-x-btn');
        if (!shareButton) return;
        shareButton.addEventListener('click', () => {
            const articleTitle = document.title; 
            const articleUrl = window.location.href; 
            const tweetText = encodeURIComponent(articleTitle);
            const tweetUrl = encodeURIComponent(articleUrl);
            const viaAccount = 'mare6b_'; 
            const xIntentUrl = `https://x.com/intent/tweet?text=${tweetText}&url=${tweetUrl}&via=${viaAccount}`;
            const width = 550; const height = 420; const left = (window.screen.width - width) / 2; const top = (window.screen.height - height) / 2;
            window.open(xIntentUrl, 'shareWindow', `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`);
        });
    }

    function initSecretFeatures() {
        let keyHistory = []; const MAX_HISTORY = 10;
        window.addEventListener('keydown', e => {
            if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') return;
            keyHistory.push(e.key.toLowerCase());
            if (keyHistory.length > MAX_HISTORY) keyHistory.shift();
            const check = seq => keyHistory.slice(-seq.length).join('') === seq;
            if (check('rabbit0')) { console.log("Secret command 'RABBIT0' triggered!"); keyHistory = []; }
            else if (check('gaming')) { document.body.classList.toggle('gaming-mode'); console.log("Gaming mode toggled!"); keyHistory = []; }
            else if (check('horror')) { document.getElementById('horror-mode-toggle')?.click(); console.log("Horror mode toggled via secret command!"); keyHistory = []; }
            else if (check('term')) { document.getElementById('terminal-mode-toggle')?.click(); console.log("Terminal mode toggled via secret command!"); keyHistory = []; }
        });
        console.log("%cT H A N K S   F O R   V I S I T I N G !", "color: #D4A373; font-size: 24px; font-family: 'Playfair Display', serif; font-weight: bold; text-shadow: 1px 1px 1px #5d4037;");
        console.log("Psst... try typing 'gaming' or 'horror' or 'term'.");
    }

    function initAccordionRipple() {
        const summaries = document.querySelectorAll('.content-accordion > summary');
        if (summaries.length === 0) return;
        summaries.forEach(summary => {
            summary.addEventListener('mousedown', function(e) {
                const rect = summary.getBoundingClientRect();
                const ripple = document.createElement('span');
                ripple.classList.add('ripple');
                const size = Math.max(summary.clientWidth, summary.clientHeight) * 2;
                ripple.style.width = `${size}px`; ripple.style.height = `${size}px`;
                ripple.style.left = `${e.clientX - rect.left - (size / 2)}px`;
                ripple.style.top = `${e.clientY - rect.top - (size / 2)}px`;
                ripple.addEventListener('animationend', () => { ripple.remove(); });
                this.appendChild(ripple);
            });
        });
    }

    function initHorrorScrollEffect() {
        window.addEventListener('scroll', function() {
            const body = document.body; 
            if (!body.classList.contains('horror-theme')) return;
            const scrollPosition = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercent = (docHeight > 0) ? (scrollPosition / docHeight) * 100 : 0;
            if (scrollPercent > 80) { body.classList.add('horror-level-3'); body.classList.remove('horror-level-2'); } 
            else if (scrollPercent > 50) { body.classList.add('horror-level-2'); body.classList.remove('horror-level-1', 'horror-level-3'); } 
            else if (scrollPercent > 25) { body.classList.add('horror-level-1'); body.classList.remove('horror-level-2', 'horror-level-3'); } 
            else { body.classList.remove('horror-level-1', 'horror-level-2', 'horror-level-3'); }
        }, { passive: true }); 
    }

    function initTocExpandButton() {
      if (window.innerWidth <= 1100) {
        const tocElements = document.querySelectorAll('.table-of-contents');
        const maxHeight = 300; 
        tocElements.forEach(toc => {
          if (toc.scrollHeight > maxHeight) {
            const expandButton = document.createElement('a');
            expandButton.className = 'toc-expand-button';
            expandButton.textContent = 'すべて表示 ▾'; expandButton.href = '#'; 
            toc.appendChild(expandButton);
            expandButton.addEventListener('click', function(event) {
              event.preventDefault(); toc.classList.add('is-expanded'); expandButton.style.display = 'none'; 
            });
          } else { toc.classList.add('is-expanded'); }
        });
      }
    }

 // ==========================================================================
    //  Ultra Rich Theme Enhancements (Texture, Glass, Neon, Particles)
    // ==========================================================================

    function initEnhancedCafeMode() {
        if (document.body.classList.contains('neo-retro-mode') || 
            document.body.classList.contains('dark-mode') ||
            document.body.classList.contains('horror-theme') ||
            document.body.classList.contains('terminal-mode')) return;

        const articleContent = document.querySelector('.article-content');
        if (!articleContent) return;
        const images = articleContent.querySelectorAll('figure.article-image:not(.full-width)');
        images.forEach(imgWrapper => {
            if (imgWrapper.querySelector('.masking-tape')) return; 
            const tape = document.createElement('div');
            tape.className = 'masking-tape';
            const tapeRotation = Math.random() * 20 - 10;
            tape.style.transform = `translateX(-50%) rotate(${tapeRotation}deg)`;
            const imgRotation = Math.random() * 2 - 1; 
            imgWrapper.style.transform = `rotate(${imgRotation}deg)`;
            imgWrapper.style.position = 'relative';
            imgWrapper.appendChild(tape);
        });

        const headings = articleContent.querySelectorAll('h2');
        headings.forEach(h2 => {
            if (h2.querySelector('.hand-drawn-line')) return;
            const svgNS = "http://www.w3.org/2000/svg";
            const svg = document.createElementNS(svgNS, "svg");
            svg.setAttribute("class", "hand-drawn-line");
            svg.setAttribute("viewBox", "0 0 300 15");
            svg.setAttribute("preserveAspectRatio", "none");
            const path = document.createElementNS(svgNS, "path");
            path.setAttribute("d", "M0,10 Q75,15 150,10 T300,10");
            svg.appendChild(path);
            h2.appendChild(svg);
        });
    }

    function initDarkParticles() {
        let canvas = document.getElementById('dark-mode-particles');
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.id = 'dark-mode-particles';
            document.body.appendChild(canvas);
        }

        const ctx = canvas.getContext('2d');
        let particles = [];
        let animationId;

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', resize);
        resize();

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 2;
                this.speedX = Math.random() * 0.5 - 0.25;
                this.speedY = Math.random() * 0.5 - 0.25;
                this.opacity = Math.random() * 0.5;
            }
            update() {
                this.x += this.speedX;
                this.y += this.speedY;
                if (this.x > canvas.width) this.x = 0;
                if (this.x < 0) this.x = canvas.width;
                if (this.y > canvas.height) this.y = 0;
                if (this.y < 0) this.y = canvas.height;
            }
            draw() {
                ctx.fillStyle = `rgba(212, 163, 115, ${this.opacity})`; 
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        const initParticles = () => {
            particles = [];
            for (let i = 0; i < 50; i++) { 
                particles.push(new Particle());
            }
        };

        const animate = () => {
            if (!document.body.classList.contains('dark-mode')) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                cancelAnimationFrame(animationId);
                return;
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.forEach(p => {
                p.update();
                p.draw();
            });
            for (let a = 0; a < particles.length; a++) {
                for (let b = a; b < particles.length; b++) {
                    const dx = particles[a].x - particles[b].x;
                    const dy = particles[a].y - particles[b].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < 100) {
                        ctx.strokeStyle = `rgba(212, 163, 115, ${0.1 - distance/1000})`;
                        ctx.lineWidth = 0.5;
                        ctx.beginPath();
                        ctx.moveTo(particles[a].x, particles[a].y);
                        ctx.lineTo(particles[b].x, particles[b].y);
                        ctx.stroke();
                    }
                }
            }
            animationId = requestAnimationFrame(animate);
        };

        initParticles();
        if (document.body.classList.contains('dark-mode')) {
            animate();
        }
        
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "class") {
                    if (document.body.classList.contains('dark-mode')) {
                        initParticles();
                        animate();
                    }
                }
            });
        });
        observer.observe(document.body, { attributes: true });
    }

    function initEnhancedDarkMode() {
        const body = document.body;
        let overlay = document.querySelector('.spotlight-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'spotlight-overlay';
            body.appendChild(overlay);
        }

        let ticking = false;
        window.addEventListener('mousemove', (e) => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    body.style.setProperty('--cursor-x', `${e.clientX}px`);
                    body.style.setProperty('--cursor-y', `${e.clientY}px`);
                    ticking = false;
                });
                ticking = true;
            }
        });

        const title = document.querySelector('.article-main-title');
        if (title && !title.querySelector('.typing-cursor') && !sessionStorage.getItem('titleTyped')) {
            const originalText = title.innerText;
            title.innerHTML = '';
            const cursor = document.createElement('span');
            cursor.className = 'typing-cursor';
            let i = 0;
            const typeWriter = () => {
                if (i < originalText.length) {
                    title.innerHTML = originalText.substring(0, i + 1);
                    title.appendChild(cursor);
                    i++;
                    setTimeout(typeWriter, 50);
                } else {
                    sessionStorage.setItem('titleTyped', 'true');
                    setTimeout(() => cursor.style.display = 'none', 3000);
                }
            };
            typeWriter();
        }
    }

    // --- Build Gallery Coverflow Slider (Shuffled) ---
    function initCoverflowSlider() {
        const slider = document.getElementById('build-gallery-swiper');
        if (!slider || typeof Swiper === 'undefined') return;

        let buildData = [
            { name: "LIM-LINさん (@S4L_LIMLIN)", x_url: "https://x.com/S4L_LIMLIN/status/1991464678955024407?s=20", case: "Frog Mini Leggera Green / G", keycaps: "KKB OHM", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "ゆきさん (@Zfba39)", x_url: "https://x.com/Zfba39/status/1991507548302921739?s=20", case: "Frog Mini Leggera L9 Cream", keycaps: "SW Beige", switch: "RAKKA Möbius", stabs: "Typeplus x YIKB" },
            { name: "Peimon1さん (@Peimon1dds)", x_url: "https://x.com/Peimon1dds/status/1991720849498673353?s=20", case: "Tofu60 Redux", keycaps: "Lucy R2", switch: "RAKKA Möbius", stabs: "Knight V4" },
            { name: "かるシウムEXさん (@Ca7xp_)", x_url: "https://x.com/Ca7xp_/status/1991843079926804625?s=20", case: "H60", keycaps: "RAKKA 80 keycap", switch: "RAKKA Möbius", stabs: "Knight V4" },
            { name: "GUPPYさん (@GUPPY_sf2)", x_url: "https://x.com/GUPPY_sf2/status/1991865134025978130?s=20", case: "Tofu60 Redux", keycaps: "PBTfans X-Ray", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "マイメロ脊髄剣さん (@u_Rea_)", x_url: "https://x.com/u_Rea_/status/1991874346454003771?s=20", case: "KBDfans Tofu60 Redux Patina Broken blade", keycaps: "Keeb-On! 「Acid Caps “Premium”」 Kirisame", switch: "RAKKA Möbius", stabs: "Typeplus x YIKB screw-in" },
            { name: "Cooさん (@Cool1shot)", x_url: "https://x.com/Cool1shot/status/1991938965876985899?s=20", case: "YMDK woodcase", keycaps: "hogtnd sideprintcap", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "かっかさん (@1kakka11)", x_url: "https://x.com/1kakka11/status/1991957264832639249?s=20", case: "KBDfans Holy60 Anodized Black", keycaps: "PBTfans WOB/PBTfans X-ray", switch: "WS Flux DC x RAKKA Möbius", stabs: "Stock" },
            { name: "やさぐれさん (@Yas4gure_EZPZ)", x_url: "https://x.com/Yas4gure_EZPZ/status/1991964200021983329?s=20", case: "Twoslab Satin60", keycaps: "PBTfans Retro Dark Lights R2", switch: "RAKKA Möbius", stabs: "Typeplus x YIKB screw-in" },
            { name: "ﾀｲｷｯﾁさん (@taikiiiiiiiiing)", x_url: "https://x.com/taikiiiiiiiiing/status/1991976529535127709?s=20", case: "Twoslab Satin60", keycaps: "白大理石2.0", switch: "Unionwell Polar Pro+", stabs: "Knight V4" },
            { name: "saraさん (@sara_zamurai)", x_url: "https://x.com/sara_zamurai/status/1992193176460005404?s=20", case: "OwLab x Wooting 60%case Black", keycaps: "Deadline Sutudio AIR Anchor", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "征竜さん (@seiryuQwQb)", x_url: "https://x.com/seiryuQwQb/status/1991528687242735860?s=20", case: "Tofu60 Redux", keycaps: "80Retros TPS1979", switch: "RAKKA Möbius", stabs: "DUROCK Transparent Clear Plate Mount" },
            { name: "ALKAさん (@ALKA98020979)", x_url: "https://x.com/ALKA98020979/status/1994800695820915005?s=20", case: "Desktop Tribe DT60", keycaps: "PBTfans Salt Lakes", switch: "RAKKA Möbius x WS DC Flux", stabs: "TX AP Long pole" },
            { name: "そふらんさん (@sokuratesu0000)", x_url: "https://x.com/sokuratesu0000/status/1993979321090752932?s=20", case: "St studio ST60 ice cracking", keycaps: "Hokkaido white & MOYU.STUDIORabbit Holiday park", switch: "Gateron jade ultra", stabs: "Swagkeys knight V4" },
            { name: "x1ηa9Kさん (@gx4xwxr)", x_url: "https://x.com/gx4xwxr/status/1993627329281798233?s=20", case: "salvation 60 copper slag", keycaps: "GMK COSMOS", switch: "RAKKA Möbius", stabs: "Swagkeys knight V4" },
            { name: "茶の人@抹茶さん (@Mattya_hokkaiDJ)", x_url: "https://x.com/Mattya_hokkaiDJ/status/1994029499961213193?s=20", case: "Aula AG60 Pro Black", keycaps: "Cerakey Matte V2 Black A set White B set", switch: "RAKKA Möbius x WS DC Flux", stabs: "Stock" },
            { name: "0timp0＠SeVeNさん (@0TIMP07)", x_url: "https://x.com/0TIMP07/status/1993660437838315957?s=20", case: "GEONWORKS frog mini leggera", keycaps: "Desktop Tribe GRDT Colorful Keycaps", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "オルカ🆇さん (@orukaorcat)", x_url: "https://x.com/orukaorcat/status/1993374699389436380?s=20", case: "PPSTUDIO 60 v2", keycaps: "PBTfans Lucy R2 + MIONI Artisan keycap", switch: "RAKKA Möbius", stabs: "Swagkeys knight V4" },
            { name: "何野何某さん (@John_Doe392)", x_url: "https://x.com/John_Doe392/status/1993364734746501254?s=20", case: "ZT60 DIY RAW", keycaps: "PBTfans WOB", switch: "RAKKA Möbius x WS DC Flux", stabs: "Typeplus x YIKB" },
            { name: "こしおさん (@kosio_ooo)", x_url: "https://x.com/kosio_ooo/status/1994981432998203791?s=20", case: "Design Roost DRK-601R", keycaps: "GMK Pulse", switch: "GravaStar UFO", stabs: "Typeplus x YIKB" },
            { name: "Fluke (くろねこさん🐈‍⬛)さん (@FlukeF23)", x_url: "https://x.com/FlukeF23/status/1993607842511966447?s=20", case: "KBDfans Holy60", keycaps: "PBTfans Origami", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "パトス / p4thosさん (@youlife1024)", x_url: "https://x.com/youlife1024/status/1994057906120216913?s=20", case: "DAMA60 Moon quartz", keycaps: "「Acid Caps “Premium”」Thin Kirisame", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "みあ@FF14/marimo_1225さん (@Miacis_W)", x_url: "https://x.com/Miacis_W/status/1993815246394540171?s=20", case: "Desktop Tribe DT60 Purple", keycaps: "「Acid Caps “Premium”」Thin Kirisame", switch: "RAKKA Möbius", stabs: "DUROCK Screw-In Stabilisers V3" },
            { name: "がばさん (@gabagavan_)", x_url: "https://x.com/gabagavan_/status/1993833327619649955?s=20", case: "KeysMe PIC60 black", keycaps: "Domikey wob obsidian", switch: "RAKKA Möbius", stabs: "Typeplus x YIKB" },
            { name: "とら𓏲𓎨さん (@ToraNyah_86)", x_url: "https://x.com/ToraNyah_86/status/1993615774628610088?s=20", case: "Morkblade MK60", keycaps: "白大理石2.0", switch: "Unionwell Polar Ink Jade", stabs: "Swagkeys knight V4" },
            { name: "ろーずなぃんさん (@RoseKey9_)", x_url: "https://x.com/RoseKey9_/status/1993613964530598023?s=20", case: "Holy60", keycaps: "Lucy R2", switch: "RAKKA Möbius", stabs: "Stock" },
            { name: "ZhynAさん (@ZhynAVLT)", x_url: "https://x.com/ZhynAVLT/status/1993221907760791974?s=20", case: "Tofu 60 redux", keycaps: "KBWOW White Cherry", switch: "Unionwell Polar pro+", stabs: "Typeplus x YIKB" },
        ];

        // シャッフル処理
        const shuffleArray = (array) => {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        };

        const swiperWrapper = slider.querySelector('.swiper-wrapper');
        const slides = Array.from(swiperWrapper.children);

        // データとHTML要素の数が一致しているか確認してからシャッフル
        if (slides.length === buildData.length) {
            const combined = buildData.map((data, index) => ({
                data: data,
                element: slides[index]
            }));

            shuffleArray(combined);

            swiperWrapper.innerHTML = ''; 
            combined.forEach(item => {
                swiperWrapper.appendChild(item.element);
            });

            buildData = combined.map(item => item.data);
        }

        const detailName = document.getElementById('build-detail-name');
        const detailXLink = document.getElementById('build-detail-x-link');
        const detailXSpan = document.getElementById('build-detail-x-user');
        const detailCase = document.getElementById('build-detail-case');
        const detailKeycaps = document.getElementById('build-detail-keycaps');
        const detailSwitch = document.getElementById('build-detail-switch');
        const detailStabs = document.getElementById('build-detail-stabs');

        const updateBuildDetails = (index) => {
            if (index >= buildData.length) index = index % buildData.length;
            const data = buildData[index];
            if (!data) return;

            if (detailName) detailName.textContent = data.name.split('(')[0].trim();
            if (detailXLink) {
                detailXLink.href = data.x_url || "#";
                const xUsername = data.name.match(/\(@(.*?)\)/);
                if (detailXSpan) detailXSpan.textContent = xUsername ? xUsername[0] : "@username";
            }
            if (detailCase) detailCase.textContent = data.case;
            if (detailKeycaps) detailKeycaps.textContent = data.keycaps;
            if (detailSwitch) detailSwitch.textContent = data.switch;
            if (detailStabs) detailStabs.textContent = data.stabs;
        };

        const swiper = new Swiper(slider, {
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            loop: true,
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
            },
            pagination: {
                el: '.coverflow-gallery-slider .swiper-pagination',
                clickable: true
            },
            on: {
                realIndexChange: (s) => {
                    updateBuildDetails(s.realIndex);
                },
                init: (s) => {
                    updateBuildDetails(s.realIndex);
                }
            }
        });
    }

    // ==========================================================================
//  Global FAQ Generator (Final Fixed Version)
// ==========================================================================

function initGlobalFAQ() {
    const container = document.getElementById('global-faq-container');
    const searchInput = document.getElementById('faq-search-input');
    const sidebarList = document.getElementById('faq-sidebar-list');

    if (!container) return;

    // -------------------------------------------------------
    // 1. 質問ライブラリ
    // -------------------------------------------------------
    const qLibrary = {
        connection: {
            q: "Q. キーボードがPCに認識されません（接続できません）。",
            a: `<p>以下の手順を順にお試しください。</p>
                <ol>
                    <li><strong>接続環境の確認:</strong> USBハブを使用せず、PC背面のUSB3.0ポートに直接接続してください。ケーブルの抜き差しも有効です。</li>
                    <li><strong>デバイスマネージャー(Windows):</strong> スタートボタン右クリック > デバイスマネージャー > キーボード > 該当デバイスを右クリックし「アンインストール」。その後ケーブルを抜き差しして再認識させてください。</li>
                    <li><strong>初期化:</strong> マニュアルを参照し、キーボードのファクトリーリセットを行ってください。</li>
                </ol>`
        },
        software_dl: {
            q: "Q. 専用ソフトウェアはどこからダウンロードできますか？",
            a: `<p><a href="{{URL}}" target="_blank" rel="noopener">こちらからダウンロード（またはアクセス）できます。</a></p>`
        },
        browser_connect: {
            q: "Q. Webドライバ（設定サイト）に接続できません。",
            a: `<p>以下の点をご確認ください。<br>1. <strong>ブラウザ:</strong> Google Chrome または Microsoft Edge を使用してください。<br>2. <strong>権限の許可:</strong> サイト接続時にポップアップが出る「HIDデバイスの接続」を必ず許可（接続）してください。<br>3. <strong>他ソフトの干渉:</strong> 他社製キーボードのソフト（WootilityやRazer Synapse等）が起動していると競合する場合があります。一時的に終了させてください。</p>`
        },
        hotswap: {
            q: "Q. ホットスワップに対応していますか？",
            a: `<p>はい、対応しています。ハンダ付け不要で、付属の工具を使って磁気スイッチの交換が可能です。</p>`
        },
        led_issue: {
            q: "Q. LEDが点灯しない / 色がおかしいです。",
            a: `<p>電力不足の可能性があります。コイルケーブルやUSBハブを使用せず、付属のケーブルでPCのマザーボードに直結してください。<br>また、誤ってショートカットキー（Fn + ↓など）で輝度を0にしていないか確認してください。</p>`
        },
        rt_settings: {
            q: "Q. ラピッドトリガー(RT)の設定方法は？",
            a: `<p>専用ソフトウェアの「Performance」または「RT」タブから設定します。<br><strong>RT(リセットポイント):</strong> 数値を小さくするほど、キーを戻した際の反応が速くなりますが、誤爆しやすくなります。まずは0.3mm〜0.5mm程度から調整することをお勧めします。</p>`
        },
        ap_settings: {
            q: "Q. アクチュエーションポイント(AP)とは何ですか？",
            a: `<p>キーが反応する「深さ」のことです。数値を小さくする（例: 0.1mm）と軽く触れただけで反応し、大きくする（例: 2.0mm）と深く押し込む必要があります。</p>`
        },
        ghost_input: {
            q: "Q. 勝手に文字が入力されます（ゴースト入力）。",
            a: `<p>磁気センサーが環境要因でズレている可能性があります。ソフトウェアから「キャリブレーション（校正）」を実行してください。<br>また、RT設定の感度が高すぎる（数値が小さすぎる）場合も発生します。数値を少し上げて様子を見てください。</p>`
        },
        drift_issue: {
            q: "Q. 長時間ゲームをしていると勝手にキーが反応するようになりました。",
            a: `<p>温度変化等の影響でセンサーの基準値がズレている可能性があります。<br>まずは<strong>USBケーブルの抜き差し（再接続）</strong>をお試しください。これだけで安定することが多いです。<br>それでも改善しない場合は、手動キャリブレーションを実行してください。（※RAKKA製品は自動キャリブレーションに対応しています）</p>`
        },
        dead_key: {
            q: "Q. 特定のキーが反応しません / 反応が悪いです。",
            a: `<p>以下の順で原因を切り分けてください。</p>
                <ol>
                    <li><strong>スイッチの入れ替え:</strong> 反応しない箇所のスイッチを抜き、正常に動く他の箇所のスイッチと入れ替えてください。入れ替えて直る場合は「スイッチの初期不良」です。</li>
                    <li><strong>キャリブレーション:</strong> スイッチを入れ替えても直らない場合、センサーの基準値がズレている可能性があります。ソフトウェアで「全キーキャリブレーション」を実行してください。</li>
                    <li><strong>異物の確認:</strong> スイッチの底面や基板の穴にゴミ（特に金属粉や磁石片）が挟まっていないか確認してください。</li>
                </ol>
                <p>上記すべてを行っても改善しない場合、基板上の磁気センサー（ホールセンサー）の故障が考えられますのでサポートまでご連絡ください。</p>`
        },
        ipi_firmware: {
            q: "Q. キーボードが反応しなくなりました（文鎮化）/ FW更新方法は？",
            a: `<p>ドライバを開き、<a href="{{URL}}" target="_blank">こちらのBinファイル</a>を使用してファームウェアを更新することで復旧する可能性があります。</p>`
        },
        ipi_disassembly: {
            q: "Q. ケースの分解方法は？",
            a: `<p>ケース上部（USB端子側）にある2か所の爪に指をかけ、上方向にゆっくり引き上げることでトップケースが外れます。</p>`
        },
        rakka_build: {
            q: "Q. 組み立てが必要ですか？",
            a: `<p>はい、本製品はセミ・アッセンブリーキットです。ケースへの基板取り付け、スイッチの装着、キーキャップの取り付けはお客様ご自身で行っていただく必要があります。詳細な手順は<a href="/blogs/blog/rakka-atlas#section-build" target="_blank">ビルドガイド記事</a>をご参照ください。</p>`
        },
        build_screw_tightness: {
            q: "Q. 【組立】ネジはどのくらい締めればいいですか？",
            a: `<p><strong>締めすぎに注意してください。</strong><br>強く締めすぎると基板が僅かに歪み、センサーと磁石の距離が変わって「触れていないのに反応する」等の誤作動原因になります。「抵抗を感じたらそこで止める」程度の強さで固定してください。</p>`
        },
        stabilizer_fix: {
            q: "Q. 【組立】大きいキー（スペースキー等）の戻りが悪いです。",
            a: `<p>スタビライザーの取り付けミス、またはルブ（潤滑剤）の塗りすぎが考えられます。<br>ワイヤーがしっかりツメに入っているか確認し、ルブが多い場合は少し拭き取ってください。</p>`
        },
        switch_orientation: {
            q: "Q. 【組立】スイッチが入らない / 向きがわかりません。",
            a: `<p>磁気スイッチには向きがあります。無理に押し込むとセンサーを破損する恐れがあります。<br>基板側のロゴマークやLEDの穴の位置と、スイッチ側の導光パーツ（またはロゴ）の向きを合わせて装着してください。</p>`
        },
switch_compat: {
            q: "Q. 他社製の磁気スイッチに交換しても動きますか？",
            a: `<p>基本的には<strong>N極対応</strong>のスイッチであれば動作しますが、可能な限りソフトウェアのリストに表示されている最適化されたスイッチの使用を推奨します。<br>磁束密度が高いスイッチを使用すると、深く押し込んだ位置で<strong>磁束の変化が非常に緩やかになってしまう（数値の変化が乏しくなる）</strong>現象が発生しやすくなります。<br>特に0.01mm単位以下のラピッドトリガー制御においては、この微細な変化をセンサーが読み取れなくなる（稀にセンサー上限を超えて飽和する）ことで、キーを戻しているのに反応が切れない<strong>『デッドゾーン』</strong>が発生する原因となります。</p>`
        },
        calibration_timing: {
            q: "Q. どのような時にキャリブレーションが必要ですか？",
            a: `<p>主に以下のタイミングで実行してください。<br>1. スイッチを交換した時<br>2. キーボードを持ち運んだ後<br>3. 気温や湿度が大きく変化した時<br>4. 入力が不安定だと感じた時</p>`
        },
        spring_exchange: {
            q: "Q. スイッチのバネ交換は可能ですか？",
            a: `<p>自己責任となりますが可能です。ただし、バネ圧が変わることで戻り位置の判定に影響が出る場合があります。<br>交換して動作が不安定になったり、違和感がある場合は、元のバネに戻してご使用ください。</p>`
        },
        oring_usage: {
            q: "Q. 静音化リング（Oリング）は使えますか？",
            a: `<p>機種や個体差によりますが、底打ちの深さが変わるため動作が不安定になることがあります。<br>使用する場合は、AP（アクチュエーションポイント）を0.1mm未満などの極端に浅い設定にしないことで安定する傾向にあります。もし動作に問題が出る場合は取り外してください。</p>`
        },
        magnetic_interference: {
            q: "Q. スピーカーや磁石の近くで使っても大丈夫ですか？",
            a: `<p>一般的なデスク環境にある磁石程度では影響ありません。<br>ただし、非常に強力な磁石（大型スピーカーの直近など）をキーボードに密着させるような配置は避けてください。</p>`
        },
        lube_policy: {
            q: "Q. スイッチのルブ(潤滑)はしてもいいですか？",
            a: `<p>推奨はしておりませんが、ご自身の判断で行っていただく分には構いません。<br>ただし、ルブが原因でセンサー付着などの故障が発生した場合は<strong>保証対象外</strong>となりますのでご注意ください。</p>`
        },
        keycap_compat: {
            q: "Q. 市販のキーキャップは使えますか？",
            a: `<p>はい、一般的なCherry MX互換（十字軸）のキーキャップが使用可能です。</p>`
        },
        rakka_keycaps: {
            q: "Q. キーキャップのサイズに注意点はありますか？",
            a: `<p>一般的なキーキャップが使用可能ですが、<strong>スペースバーの分割</strong>に注意が必要です。<br>RAKKA Atlas等は「2.25u / 1.25u / 2.75u」または「3u / 1u / 3u」のパターンに対応しているため、これらのサイズが含まれるキーキャップセットをご購入ください。</p>`
        }
    };

    // -------------------------------------------------------
    // 2. 機種ごとの構成データ
    // -------------------------------------------------------
    const keyboardConfig = [
        {
            brand: "HM Lab",
            models: [
                { name: "HM Z Platform", url: "https://hmlab.tech/", types: ["connection", "software_dl", "hotswap", "led_issue", "rt_settings", "ap_settings", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "HM 66", url: "https://www.dropbox.com/scl/fo/xyp7h7oc1b3d4fxcs2sgw/AMj33tXFeSTpTajl1GZEiiY?rlkey=eel4dvvcls7ae10856im871ab&st=jb7vcpc0&dl=0", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "HM 80", url: "https://www.dropbox.com/scl/fi/q82iq8bl2sxasou7jjzga/hm-mag-v2.6.0.exe?rlkey=7bokjlu7zoskjpj3kfl6s7gy3&st=gph0wdin&dl=0", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] }
            ]
        },
        {
            brand: "IPI",
            models: [
                { 
                    name: "IPI AURORA65", 
                    url: "https://hub.ipigame.cn/#/connect", 
                    types: ["connection", "software_dl", "browser_connect", "hotswap", "ipi_firmware", "ipi_disassembly", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ]
        },
        {
            brand: "MelGeek",
            models: [
                { name: "MelGeek REAL67", url: "https://hive.melgeek.com/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "MelGeek MADE68 / Pro / Ultra / Air", url: "https://hive.melgeek.com/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "MelGeek MOJO68 RT", url: "https://hive.melgeek.com/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ]
        },
        {
            brand: "RAKKA",
            models: [
                { 
                    name: "RAKKA EDGE80 / 60ATLAS", 
                    url: "https://kb.rakka.dev/", 
                    types: ["connection", "software_dl", "browser_connect", "rakka_build", "build_screw_tightness", "stabilizer_fix", "switch_orientation", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "rakka_keycaps", "magnetic_interference"] },
            ]
        },
        {
            brand: "MorkBlade",
            models: [
                { name: "MorkBlade MK60 / Bold TKL", url: "https://www.morkblade.games/", types: ["connection", "software_dl", "browser_connect", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ]
        },
        {
            brand: "MM Studio",
            models: [
                { name: "MM Studio M6Lite+ / Pro+", url: "https://www.dropbox.com/scl/fo/t3q12ndo40bsov7xjvhb5/APMfg7fYrWHK7QmY-TLg7VI?rlkey=2do7da9j8kmn4ggb42qgoo0zb&st=vm6j5f6d&dl=0", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] }
            ]
        },
        {
            brand: "Irok / IYX",
            models: [
                { name: "Irok MG68 / Plus", url: "https://driver.irok.cc/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "Irok MG75 / Pro", url: "https://driver.irok.cc/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "Irok ND63 Pro", url: "https://driver.irok.cc/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "IYX MU68 Pro / Ultra", url: "https://driver.irok.cc/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "IYX Polar75", url: "https://driver.irok.cc/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ]
        },
        {
            brand: "EverGlide",
            models: [
                { name: "EverGlide SU68 / SU75", url: "https://www.dropbox.com/scl/fo/t3q12ndo40bsov7xjvhb5/APMfg7fYrWHK7QmY-TLg7VI?rlkey=2do7da9j8kmn4ggb42qgoo0zb&st=vm6j5f6d&dl=0", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "EverGlide SU75 Pro", url: "https://xsyd.top/connect", types: ["connection", "software_dl", "browser_connect", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ]
        },
        {
            brand: "Mchose",
            models: [
                { name: "Mchose Ace60 Pro / Ace68 / Jet75 / Mix87", url: "https://www.mchose.com.cn/#/home", types: ["connection", "software_dl", "browser_connect", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ],
        },
        {
            brand: "Weikav",
            models: [
                { name: "Weikav K-ONE80", url: "https://k-one.mkbms.cn", types: ["connection", "software_dl", "browser_connect", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ],  
        },    
        {
            brand: "Yodall",
            models: [
                { name: "Yodall Nexus61S", url: "https://yodall.keybord.net.cn/", types: ["connection", "software_dl", "rakka_build", "build_screw_tightness", "stabilizer_fix", "switch_orientation", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ],    
        },    
        {
            brand: "MMDAiny",
            models: [
                { name: "MMD AR60", url: "https://gb.tabkb.com/", types: ["connection", "software_dl", "rakka_build", "build_screw_tightness", "stabilizer_fix", "switch_orientation", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ],  
        },  
        {
            brand: "Wraith",
            models: [
                { name: "Wraith W60", url: "https://wraith.software/", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
                { name: "Wraith W75", url: "https://cdn.shopify.com/s/files/1/0564/0096/9921/files/Wraith_Installer_V2.05.01.zip?v=1725887795", types: ["connection", "software_dl", "hotswap", "rt_settings", "ap_settings", "led_issue", "ghost_input", "dead_key", "drift_issue", "switch_compat", "calibration_timing", "lube_policy", "spring_exchange", "oring_usage", "keycap_compat", "magnetic_interference"] },
            ],  
        },  
    ];  

    // -------------------------------------------------------
    // 3. HTML生成ロジック
    // -------------------------------------------------------
    const createHTML = () => {
        let fullHtml = '<div class="faq-list-container">';
        let sidebarHtml = '';
        
        // サイドバー：検索リンク
        sidebarHtml += `<li><a href="#" onclick="document.getElementById('faq-search-input').focus(); return false;"><i class="fa-solid fa-magnifying-glass"></i> 機種を検索する</a></li>`;
        sidebarHtml += `<li><hr style="margin: 10px 0; border-top: 1px dashed var(--border-color);"></li>`;

        keyboardConfig.forEach((group) => {
            const brandId = `brand-${group.brand.replace(/\s+/g, '-').toLowerCase()}`;
            // サイドバー：ブランドリンク
            sidebarHtml += `<li><a href="#${brandId}">${group.brand}</a></li>`;
            // メイン：ブランド見出し
            fullHtml += `<h2 id="${brandId}" class="faq-brand-heading" data-brand="${group.brand}">${group.brand}</h2>`;
            
            group.models.forEach(model => {
                fullHtml += `
                <details class="faq-keyboard-section faq-item" data-keyboard-name="${model.name}" data-keywords="${group.brand} ${model.name}">
                    <summary class="keyboard-header"><h3>${model.name}</h3></summary>
                    <div class="keyboard-content" style="padding: 15px 20px;">
                `;
                model.types.forEach(typeId => {
                    const qData = qLibrary[typeId];
                    if (qData) {
                        let answerText = qData.a;
                        if (typeId === 'ipi_firmware') {
                             answerText = answerText.replace('{{URL}}', "https://drive.google.com/drive/folders/1JS1zg3SbxUPva-AdFooVsqIonwvZa4sk");
                        } else if (model.url && answerText.includes('{{URL}}')) {
                             answerText = answerText.replace('{{URL}}', model.url);
                        }

                        fullHtml += `<details class="faq-item sub-item" style="margin-bottom: 10px; border-bottom: 1px dashed var(--border-color);"><summary style="font-size: 0.95em;">${qData.q}</summary><div class="faq-answer" style="font-size: 0.9em;">${answerText}</div></details>`;
                    }
                });
                fullHtml += `</div></details>`;
            });
        });

        fullHtml += '</div>';
        container.innerHTML = fullHtml;

        // サイドバー：戻るリンク
        sidebarHtml += `<li><hr style="margin: 10px 0; border-top: 1px dashed var(--border-color);"></li>`;
        sidebarHtml += `<li><a href="#GLOBAL-FAQ-PAGE">ページの一番上に戻る</a></li>`;
        
        if (sidebarList) {
            sidebarList.innerHTML = sidebarHtml;
        }
    };

    createHTML();

    // -------------------------------------------------------
    // 4. 検索機能
    // -------------------------------------------------------
    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            const query = e.target.value.toLowerCase().trim();
            const brandHeadings = container.querySelectorAll('.faq-brand-heading');
            const modelSections = container.querySelectorAll('.faq-keyboard-section');

            modelSections.forEach(section => {
                const keywords = section.dataset.keywords.toLowerCase();
                section.style.display = keywords.includes(query) ? 'block' : 'none';
            });

            brandHeadings.forEach(heading => {
                let hasVisibleModel = false;
                let nextElem = heading.nextElementSibling;
                while(nextElem && !nextElem.classList.contains('faq-brand-heading')) {
                    if (nextElem.classList.contains('faq-keyboard-section') && nextElem.style.display !== 'none') {
                        hasVisibleModel = true;
                        break;
                    }
                    nextElem = nextElem.nextElementSibling;
                }
                heading.style.display = hasVisibleModel ? 'block' : 'none';
            });
        });
    }
}

    // --- Final Initialization Sequence ---
    runSafely(initDarkMode, "Dark Mode");
    runSafely(initHorrorMode, "Horror Mode");
    runSafely(initTerminalMode, "Terminal Mode"); 
    runSafely(initFitText, "Fit Text (Parallax Title)");
    runSafely(initParallaxHeader, "Parallax Header Effect");
    runSafely(initScrollAnimations, "Scroll Reveal Animations");
    runSafely(initGlobalTabs, "Global Tabs (Image Switcher)"); 
    runSafely(initSmoothScroll, "Smooth Scroll Links");
    runSafely(initTocAccordionClick, "TOC Accordion Click Setup"); 
    runSafely(initTocHighlightAndAccordion, "TOC Highlighting & Auto-Open"); 
    runSafely(initProductSlider, "Product Image Sliders");
    runSafely(initRadarChart, "Radar Chart");
    runSafely(initAudioEqualizer, "Audio Equalizer");
    runSafely(initSimulator, "AP/RT Simulator"); 
    runSafely(initKeyboardFinder, "Keyboard Finder"); 
    runSafely(initRankingSort, "Ranking Table Sort"); 
    runSafely(initSecretFeatures, "Secret Konami Codes");
    runSafely(initXShareButton, "X Share Button");
    runSafely(initAccordionRipple, "Content Accordion Ripple");
    runSafely(initHorrorScrollEffect, "Horror Scroll Effect"); 
    runSafely(initTocExpandButton, "TOC Expand Button");
    runSafely(initEnhancedCafeMode, "Enhanced Cafe Mode");
    runSafely(initEnhancedDarkMode, "Enhanced Dark Mode");
    runSafely(initDarkParticles, "Dark Mode Particles"); 
    runSafely(initGlobalFAQ, "Global FAQ Generator");
    
    // 【Focus Mode の初期化を追加】
    runSafely(initializeFocusMode, "Focus Mode Toggle"); 
    
    runSafely(initNeoRetroMode, "Neo-Retro Magazine Mode");
    runSafely(initCoverflowSlider, "Build Gallery Coverflow");
    
    setTimeout(() => runSafely(initImageLightbox, "Image Lightbox"), 0);
});

// モード切り替えボタン用リスナー
    ['dark-mode-toggle', 'neo-retro-mode-toggle', 'horror-mode-toggle', 'terminal-mode-toggle'].forEach(id => {
        document.getElementById(id)?.addEventListener('click', () => {
            setTimeout(() => {
                runSafely(initEnhancedCafeMode, "Re-init Cafe");
                // Dark Mode系の再描画はMutationObserverで自動化しているので呼び出し不要
            }, 100);
        });
    });